// Imports (βεβαιώσου ότι έχεις τα ίδια imports που είχες στο προηγούμενο ολοκληρωμένο αρχείο)
import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef // Χρειάζεται ακόμα αυτό
} from "@angular/core";
import { MatTableModule } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatIcon } from "@angular/material/icon";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { merge, of as observableOf, Subject, EMPTY } from "rxjs";
import {
  catchError,
  map,
  startWith,
  switchMap,
  takeUntil,
  delay,
  filter,
} from "rxjs/operators";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { SocialAICreateomateVideoI } from "../../../interfaces/core.interface";
import { CoreService } from "../../../services/core.service";
import { DialogComponent } from "../../dialog/dialog.component";
import { SocialAiAdminManageVideoTemplateFormComponent } from "../../forms/create-account/video-template-form/video-template-form.component";


@Component({
  selector: "app-social-ai-admin-manage-video-template-table",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginator,
    MatIcon,
    MatToolbarModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    SocialAiAdminManageVideoTemplateFormComponent
  ],
  templateUrl: "./social-ai-video-template-table.component.html",
  styleUrl: "./social-ai-video-template-table.component.scss",
})
export class SocialAiAdminManageVideoTemplateTableComponent
  implements OnDestroy, AfterViewInit {

  private _companyID: string | null = null;
  private companyIdStream$ = new Subject<void>(); // Διατηρούμε αυτό για να triggerάρουμε φόρτωση όταν αλλάζει το companyID
  private destroy$ = new Subject<void>();
  video: SocialAICreateomateVideoI = {} as SocialAICreateomateVideoI;

  @Input()
  set companyID(id: string | null) {
    if (this._companyID !== id) {
      this._companyID = id;
      if (this.paginator) {
        this.paginator.pageIndex = 0; // Reset page on companyID change
      }
      this.companyIdStream$.next(); // Trigger data reload
    }
  }

  get companyID(): string | null {
    return this._companyID;
  }

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild("videoFormTmpl", { static: true })
  videoFormTmpl!: TemplateRef<any>;
  @ViewChild("confirmDeleteTmpl", { static: true })
  confirmDeleteTmpl!: TemplateRef<any>;

  dataSource = new MatTableDataSource<SocialAICreateomateVideoI>();
 displayedColumns: string[] = [
  "createomate_id",
  "template_name",
  "template_id",
  "slides_number",
  "feed",
  "isApproved",
  "actions",
];

  totalItems: number = 0;

  constructor(private coreService: CoreService, public dialog: MatDialog, private cdr: ChangeDetectorRef) { }

  buildQueryParams(): any {
    const params: any = {
      sortBy: this.sort?.active || '',
      sortOrder: this.sort?.direction || '',
      offset: (this.paginator?.pageIndex ?? 0) * (this.paginator?.pageSize ?? 50),
      limit: this.paginator?.pageSize ?? 50
    };

    if (this.companyID) {
      params.companyID = Number(this.companyID);
    }
    return params;
  }


  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page, this.companyIdStream$)
      .pipe(
        startWith({}),
        switchMap(() => {
          const params = this.buildQueryParams();
          return this.coreService.getData('/getVideoTemplates', params)
            .pipe(catchError(() => observableOf(null)));
        }),
        map((data) => {
          return data;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.dataSource = data.data;
        this.totalItems = data.total;
      });

    if (this._companyID !== null) {
      this.companyIdStream$.next();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addNewVideoTemplate(): void {

    if (this.companyID === null) {
      this.coreService.showSnackbar("Please select a company first.");
      return;
    }

    this.video = {
      createomateCompanyID: Number(this.companyID)
    } as SocialAICreateomateVideoI;

    this.dialog.open(DialogComponent, {
      data: {
        content: this.videoFormTmpl,
        header: "Add Video Template",
        cls: "!bg-slate-600 !text-white",
      },
      width: "500px",
      maxWidth: "500px",
    });
  }

  editVideoTemplate(row: SocialAICreateomateVideoI): void {
    this.video = row;
    this.dialog.open(DialogComponent, {
      data: {
        content: this.videoFormTmpl,
        header: "Edit Content Site",
        cls: "!bg-slate-600 !text-white",
      },
      width: "500px",
      maxWidth: "500px",
    });
  }

  openDeleteVideoTemplateConfirm(row: SocialAICreateomateVideoI) {
    this.video = row;
    this.dialog.open(DialogComponent, {
      data: {
        content: this.confirmDeleteTmpl,
        header: "Delete Video Template?",
        cls: "bg-red-500 !text-white",
      },
    });
  }

  deleteVideoTemplate(): void {
    const videoIdToDelete = this.video.createomate_id || (this.video as any).ID;
    if (!videoIdToDelete) {
      this.coreService.showSnackbar("Video Template ID is missing for deletion.");
      return;
    }

    this.coreService
      .deleteData("deleteCreateomateVideoTemplate", String(videoIdToDelete))
      .pipe(
        catchError((error) => {
          console.error("Error deleting site:", error);
          this.coreService.showSnackbar("Error deleting site. Please try again.");
          return observableOf(null);
        })
      )
      .subscribe((result) => {
        if (result !== null) {
          this.coreService.showSnackbar("Video template deleted successfully!");
          this.onSubmitClbk();
        }
      });
  }

  onStatusChange(element: SocialAICreateomateVideoI): void {
    if (element.isApproved === 'Approved') {
      this.setApprovestatus(element);
    } else if (element.isApproved === 'Not Approved') {
      this.setNotApprovedStatus(element);
    }
  }

  setApprovestatus(row: SocialAICreateomateVideoI): void {
    this.coreService.postData('videoTemplate/approve', { ID: row.createomate_id }).subscribe({
      next: (data) => {
        this.onSubmitClbk();
      },
      error: (error) => {
        console.error("Error updating approval status:", error);
        this.coreService.showSnackbar("Error updating approval status.");
      }
    });
  }

  setNotApprovedStatus(row: SocialAICreateomateVideoI): void {
    this.coreService.postData('videoTemplate/decline', { ID: row.createomate_id }).subscribe({
      next: (data) => {
        this.onSubmitClbk();
      },
      error: (error) => {
        console.error("Error updating approval status:", error);
        this.coreService.showSnackbar("Error updating approval status.");
      }
    });
  }

  onSubmitClbk(): void {
    this.dialog.closeAll();
    this.companyIdStream$.next(); // Trigger data reload
  }

}